import * as React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { clientApi } from '../../../../../api/clientApi';
import { NoNavigationPageWrapper } from '../../../../../designSystem/layouts/pageWrappers/NoNavigationPageWrapper';
import { SingleColumnLayout } from '../../../../../designSystem/layouts/SingleColumnLayout';
import { LoadingPageOverlay } from '../../../../../designSystem/LoadingPageOverlay';
import { PageHeader } from '../../../../../designSystem/PageHeader';
import { PublicPageProvider } from '../../../../_contexts/PublicPageContext';
import { P } from '../../../../../designSystem/typography/Body';
import { applicationEndpoints } from '../../../../../amorg-common/applicationEndpoints';

// type loginMethod = 'none' |'magicLink';

export function PortalAccessKeyPage(): JSX.Element {
    
    const params = useParams<{ siteId:string, accessKey:string }>();

    const [loading, setLoading] = React.useState(true);
    const [success, setSuccess] = React.useState<boolean | null>(null);

    React.useEffect(() => {
        async function getData() {
            if(!params.siteId || !params.accessKey)
            {
                setSuccess(false);
                setLoading(false);
                return;
            }

            const result = await clientApi.portal.accessKeyLogin(params.siteId, params.accessKey);
            setSuccess(result);
            setLoading(false);
        }
        getData();
    },[params.siteId, params.accessKey]);

    return (
        <PublicPageProvider>
            <NoNavigationPageWrapper>

                {loading &&
                    <LoadingPageOverlay loading={true} />
                }

                {success 
                    
                    ?
                    <Navigate to={applicationEndpoints.portal} />

                    :
                    <SingleColumnLayout
                        noDivider
                        headerContainer={
                            <PageHeader headerText="Bekræft login" headerStyle='primary-black' />
                        }
                        contentContainer={
                            <>
                                <P>Vi kunne ikke logged dig ind.</P>
                                
                                <P>Kontakt din arbejdsmiljørepræsentant for hjælp.</P>
                            </>
                        }
                    />
                }
            </NoNavigationPageWrapper>
        </PublicPageProvider>
    );
}